<div class="policy-summary">
  <cpds-alert *ngIf="alert" [intent]="alert.intent">{{ alert.text }}</cpds-alert>
  <h3 class="policy-summary__intro policy-summary__heading--top">
    <span *ngIf="isInForce()" class="policy-summary__heading-item">Your Policies</span>
    <span *ngIf="!isInForce()" class="policy-summary__heading-item">Your Application</span>
  </h3>
  <h3 class="policy-summary__heading-medium policy-summary__heading--bottom">
    <div class="policy-summary__heading-item">
      <span class="policy-summary__face-amount">{{ formatFace(primaryPolicyFaceAmount) }}</span>
      <span class="policy-summary__policy-description">
        {{ getProductDescription(primaryPolicyData) }}
        <span *ngIf="isJointApp">&amp;</span>
      </span>
    </div>
  </h3>
  <h3 *ngIf="isJointApp" class="policy-summary__heading-medium policy-summary__heading--bottom">
    <div class="policy-summary__heading-item">
      <span class="policy-summary__face-amount">{{ formatFace(secondaryPolicyFaceAmount) }}</span>
      <span class="policy-summary__policy-description">
        {{ getProductDescription(secondaryPolicyData) }}
      </span>
    </div>
  </h3>
  <div *ngIf="showAmendmentInformation()" class="policy-summary__amend-info policy-summary__heading--item">
    <div *ngIf="getPendingAmendmentDateFormatted()" class="policy-summary__amend-info--date-time">
      Updated by {{ getAgentName() }} on {{ getPendingAmendmentDateFormatted() }}
    </div>
    <div class="policy-summary__amend-info--change-text">
      Need to change something?
      <tooltip
        [helpText]="'Contact your financial professional for help changing your application details before you sign.'"
      >
        >
      </tooltip>
    </div>
  </div>
</div>
